import { Action } from 'redux'
import { notification } from 'antd'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditNotificationPayload } from '@app-store/slices/eventSettings/editNotification'

interface TaskAction extends Action {
    payload: IEditNotificationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventSetting.editNotification

function* editNotificationSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.put(`/event/settings/${payload.settingId}/notification`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Notification setting updated successfully.',
                duration: 5000
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editNotificationSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editNotificationSagaTask)
}

export default editNotificationSaga
